import { mediaQueries, palette } from '@centivo/react-components'
import styled from 'styled-components'

import { ContentSection } from 'src/refactor/structure'
import sliceArrow from 'src/assets/Images/backgrounds/slice-background-arrow.svg'

export const StyledEligibility = styled(ContentSection)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  h1 {
    position: relative;
    font-weight: 500;
    max-width: 1130px;
    line-height: 100%; /* 72px */
    letter-spacing: -2.16px;
    font-size: 4.5rem;

    color: ${palette.brand.darkGreen};

    &::after {
      content: '';
      display: block;
      position: absolute;
      width: 160px;
      height: 160px;
      background: url(${sliceArrow}) no-repeat 50%;
      right: 32px;
      top: 88px;

      @media (max-width: 1280px) {
        top: 48px;
        right: -20px;
        width: 120px;
        height: 120px;
        background-size: cover;
      }

      @media ${({ theme }) => theme.mediaQueries.mobile} {
        display: none;
      }
    }

    @media (max-width: 1280px) {
      font-size: 3rem;
      max-width: 740px;
    }

    @media ${({ theme }) => theme.mediaQueries.mobile} {
      font-size: 3rem;
      max-width: calc(100vw - 2.5rem);
      text-align: left;
      margin-top: 1.5rem;
    }
  }

  h3 {
    font-size: 1.25rem;
    font-weight: 400;
    color: ${palette.brand.darkGreen};
    max-width: 900px;
    margin: 42px 0 32px;
    line-height: 140%; /* 28px */
    letter-spacing: -0.6px;

    b {
      font-weight: 700;
    }

    @media (max-width: 1280px) {
      margin: 32px 0 20px;
      font-size: 1rem;
      max-width: 740px;
    }

    @media ${({ theme }) => theme.mediaQueries.mobile} {
      margin: 40px 0 52px;
      font-size: 1.25rem;
      max-width: calc(100vw - 2.5rem);
      text-align: left;
    }
  }

  h6 {
    font-size: 24px;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.brand.darkPurple};
    margin-bottom: 48px;
    letter-spacing: -0.72px;

    @media ${mediaQueries.desktop} {
      width: auto;
    }

    @media ${mediaQueries.mobile} {
      text-align: left;
    }
  }

  .eligibility-form-content {
    align-items: center;
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1106px;
    background-color: ${({ theme }) => theme.palette.brand.lightPurple};
    border-radius: 40px;
    padding: 64px 0 80px;

    @media ${({ theme }) => theme.mediaQueries.mobile} {
      max-width: unset;
      width: 100vw;
      border-radius: 0;
      padding: 40px 37.5px 80px;
    }

    .zip-search {
      width: 90%;
      max-width: 27.5rem;

      input {
        padding-left: 2.8rem;
        padding-bottom: 4px;
        font-weight: 400;
        color: #212121;
        border-radius: 10px;
      }

      label {
        color: #59616e;
        padding-left: 2rem;
        font-weight: 400;
      }

      button[aria-label='clear'] {
        margin-top: 2px;
      }

      @media ${({ theme }) => theme.mediaQueries.mobile} {
        width: 100%;
        max-width: unset;
      }
    }

    p {
      position: absolute;
      top: 210px;
      font-size: 1rem;
      font-weight: 500;
      line-height: 120%; /* 19.2px */
      letter-spacing: -0.48px;
      color: ${({ theme }) => theme.palette.brand.darkGreen};
      margin: 1rem 0 0.625rem;
      width: 17.5rem;

      b {
        font-weight: 700;
      }

      @media ${mediaQueries.desktop} {
        font-size: 0.875rem;
        width: auto;
      }

      @media ${mediaQueries.mobile} {
        top: 240px;
        font-size: 0.75rem;
        text-align: left;
      }

      a {
        color: ${({ theme }) => theme.palette.brand.darkGreen};
        text-decoration: underline;
      }
    }

    a.hero-button {
      font-size: 0.875rem;
      width: 13rem;
      &:hover {
        color: #fff;
      }
    }
  }
`

export const DashImage = styled.img`
  width: 100vw;
`
